module.exports = __webpack_public_path__ + "static/media/landpage-register.0ddae04e.png";